import {get} from 'lodash'

// PT-6264: Apollo v2 tags a request with `networkError` for connection failures/timeouts,
// even when the mutation already committed server-side, and with `graphQLErrors` for a
// proven, server-side rejection. Only the latter is safe to unlock a submit control for a
// retry — an ambiguous (network) failure must keep it locked until the operator has verified
// the actual outcome, otherwise a second click can book the same money movement twice.
export const isAmbiguousMutationFailure = (error: any): boolean => !!get(error, 'networkError')
